// extracted by mini-css-extract-plugin
module.exports = {"container":"IconButton_container__KlAXc","image":"IconButton_image__zE_U0"};